// extracted by mini-css-extract-plugin
export default {"Container":"ShipmentDetail_Container__z+jjo","LastRefresh":"ShipmentDetail_LastRefresh__GlVtI","Header":"ShipmentDetail_Header__qSNZ9"};